import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-1" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "mb-8 d-flex align-center" }
const _hoisted_4 = { class: "my-8" }
const _hoisted_5 = { class: "font-weight-bold" }
const _hoisted_6 = { class: "font-weight-bold" }
const _hoisted_7 = { class: "font-weight-bold" }
const _hoisted_8 = { class: "font-weight-bold" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "font-weight-bold" }
const _hoisted_12 = { class: "font-weight-bold" }
const _hoisted_13 = { class: "font-weight-bold" }
const _hoisted_14 = { class: "font-weight-bold" }
const _hoisted_15 = { class: "font-weight-bold" }
const _hoisted_16 = { class: "font-weight-bold" }
const _hoisted_17 = { class: "font-weight-bold" }
const _hoisted_18 = { class: "font-weight-bold" }
const _hoisted_19 = { class: "font-weight-bold" }
const _hoisted_20 = { class: "font-weight-bold" }
const _hoisted_21 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_breadcrumbs, {
        class: "px-0",
        items: _ctx.accountBreadcrumbItems
      }, null, 8, ["items"])
    ]),
    (_ctx.child)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.child.lastName) + " " + _toDisplayString(_ctx.child.firstName), 1),
            _createVNode(_component_v_spacer),
            _createElementVNode("div", null, [
              _createVNode(_component_v_btn, {
                color: "primary",
                class: "mr-4",
                variant: "outlined",
                onClick: _ctx.invitationDownload,
                disabled: _ctx.isDownloading || _ctx.loading
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { start: "" }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("mdi-tray-arrow-down", -1)
                    ]))]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('children.invitationDownload')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              _createVNode(_component_v_btn, {
                onClick: _ctx.deleteChild,
                disabled: _ctx.loading,
                class: "mr-4",
                color: "error",
                variant: "flat"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              _createVNode(_component_v_btn, {
                disabled: _ctx.loading,
                color: "primary",
                variant: "flat",
                to: `/children/account/${_ctx.child.childId}/edit`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.edit')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "to"])
            ])
          ]),
          _createElementVNode("div", null, [
            (_ctx.isDownloading)
              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                  key: 0,
                  indeterminate: "",
                  color: "primary",
                  class: "my-8"
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_img, {
              width: "200px",
              src: _ctx.child.imageUrl
            }, null, 8, ["src"])
          ]),
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('children.childInformation')), 1),
          _createVNode(_component_v_table, { class: "mt-4" }, {
            default: _withCtx(() => [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.$t('children.childcareType')), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.childType), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.$t('children.loginId')), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.child.childCode), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.$t('children.initialPassword')), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.child.password), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$t('children.childCode')), 1),
                  _createElementVNode("td", null, [
                    (_ctx.child.optionalChildCode1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.child.optionalChildCode1) + ", ", 1))
                      : _createCommentVNode("", true),
                    (_ctx.child.optionalChildCode2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.child.optionalChildCode2), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.$t('children.dateOfBirth')), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDisplayDate(_ctx.child.dateOfBirth)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.$t('common.gender')), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.child.gender == "male" ? _ctx.$t('common.male') : _ctx.$t('common.female')), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.$t('children.admissionDate')), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDisplayDate(_ctx.child.admissionDate)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.$t('children.graduationDate')), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDisplayDate(_ctx.child.graduationDate)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.$t('children.withdrawalDate')), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDisplayDate(_ctx.child.quitDate)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.$t('common.class')), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.classNames), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.$t('children.group')), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.groupNames), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.$t('children.extendedCarePattern')), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.child.hoursPattern ? _ctx.child.hoursPattern.patternTitle : ""), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.$t('children.additionalStaffForSpecialNeeds')), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.child.additionalStaffNum), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.$t('children.maxSubsidyAmount')), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.child.maxSubsidyAmount), 1)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createElementVNode("h3", _hoisted_21, _toDisplayString(_ctx.$t('children.loginInformation')), 1),
          _createVNode(_component_v_table, { class: "mt-4" }, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('common.name')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('children.relationship')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('children.loginMethod')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('children.registeredEmail')), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authMethodsResponse, (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", null, _toDisplayString(`${item.parentUser.lastName || ""} ${
                    item.parentUser.firstName || ""
                  }`), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.getParentTypeText(item.parentUser.parentType)), 1),
                    _createElementVNode("td", null, _toDisplayString(item.method == "auth0"
                    ? this.$t('children.emailAndPassword')
                    : item.method), 1),
                    _createElementVNode("td", null, _toDisplayString(item.method == "apple" ? "" : `${item.parentUser.email || ""}`), 1)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}